__webpack_require__.p = "https://static.parastorage.com/services/ecom-platform-cart-icon/932ee355ae703b627d55c4df01aee36e3d3e38704aa3ec9701982c6d/";